import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Scrollbar, SpinnerLoader, Tabs, Typography } from 'shared/ui'
import { type SurveyRow } from 'entities/Surveys/model/SurveyRow'
import { SurveyStatus } from 'entities/Surveys'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { DetailsSurveyModalStore } from 'pages/surveys/ui/actions/detailsSurvey/store/detailsSurveyModalStore'
import { ContactEnrollmentTab } from './ContactEnrollmentTab'
import styles from './styles.module.scss'
import { ScoreElaborationTab } from './ScoreElaborationTab/ScoreElaborationTab'
import { ClosingMessageTab } from './ClosingMessageTab/ClosingMessageTab'
import { ActionsTab } from './ActionsTab/ActionsTab'

type IDetailsSurveyModalContentProps = {
  survey: SurveyRow
  store: DetailsSurveyModalStore
}

const DetailsSurveyModalContent = observer(({ survey, store }: IDetailsSurveyModalContentProps) => {
  const { loading, tabs, activeTabKey, setActiveTab } = store
  return (
    <div className={styles.wrap}>
      <Box padding={'0 24px'} display={'flex'}>
        <Typography ariaLabel={'SurveyDetailsName'} variant={'heading-lg'} ellipsis>
          {survey.name}
        </Typography>
      </Box>
      <div className={styles.status}>
        <SurveyStatus status={survey.status} />
      </div>

      {loading ? (
        <SpinnerLoader ariaLabel={'DetailsSurveyModal'} />
      ) : (
        <Box height={'100%'}>
          <Box padding={'0 18px'}>
            <Tabs tabs={tabs} activeTabKey={activeTabKey} handleSelectTab={setActiveTab} />
          </Box>
          <Scrollbar autoHeight autoHeightMax={'calc(100% - 28px)'}>
            {activeTabKey === 'contactEnrollment' && <ContactEnrollmentTab store={store} />}
            {activeTabKey === 'scoreElaboration' && <ScoreElaborationTab />}
            {activeTabKey === 'closingMessage' && <ClosingMessageTab />}
            {activeTabKey === 'actions' && <ActionsTab />}
          </Scrollbar>
        </Box>
      )}
    </div>
  )
})

export const DetailsSurveyModal = observer(({ survey }: { survey: SurveyRow }) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new DetailsSurveyModalStore(survey.id, entities))

  return <DetailsSurveyModalContent survey={survey} store={store} />
})
